import React from "react";

import { Chip, ChipWrapper } from "components/Chip";

interface ScanLabelsRendererParams {
  value: string | null;
  data: {
    scanLabels?: ScanLabel[];
  };
}

export function ScanLabelsRenderer({ value, data }: ScanLabelsRendererParams) {
  if (!value) {
    return null;
  }
  return (
    <ChipWrapper>
      {data?.scanLabels?.map(label => (
        <Chip key={label.id}>{label.name || label.archetype}</Chip>
      ))}
    </ChipWrapper>
  );
}
